module.exports = __webpack_public_path__ + "static/img/contant_3.20de398.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_9/contant_3.png
// module id = R8jM
// module chunks = 0